<template>
  <video controls autoplay loop ref="video"/>
</template>

<script>
import Hls from 'hls.js'

const hls = new Hls()

export default {
  props: {
    source: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 1920
    },
    width: {
      type: Number,
      default: 1080
    }
  },
  mounted () {
    hls.loadSource(this.source)
    hls.attachMedia(this.$refs.video)
  },
  beforeDestroy () {
    hls.detachMedia(this.$refs.video)
  }
}
</script>

<style>

</style>
